import React from 'react';
import cx from 'classnames';
import { useDefaultCardData } from 'constants/cardDefaults';
import { CardGroup, QuoteCard } from 'library';
import useSpecificPage from 'utils/useSpecificPage';

import { mapStoryToComponent } from '../../blocks/CardGroupBlock/cardGroupBlockUtils';
import RelatedPostsWrapper from '../../common/RelatedPostsWrapper/RelatedPostsWrapper';

import './HomeownerQuotes.scss';

const HomeownerQuotes = ({ title, text, buttonLabel, buttonLink, cardData }) => {
  let cards = useDefaultCardData({ cardType: 'stories' });
  if (cardData) {
    cards = cardData.map(mapStoryToComponent);
  }
  const filteredCards = cards.filter((card) => card);

  const { isWhyHometapPage, isIdeasPage, isHome } = useSpecificPage();
  const allowShareStory = isHome || isWhyHometapPage || isIdeasPage;

  return (
    !!filteredCards.length && (
      <RelatedPostsWrapper
        theme="dark"
        buttonLabel={buttonLabel}
        buttonLink={buttonLink}
        allowShareStory={allowShareStory}
      >
        <CardGroup
          cardSize={QuoteCard.size}
          title={title}
          text={text}
          className={cx('HomeownerQuotes', text && 'hasText')}
          preventOrphans
        >
          {filteredCards.map((data, i) => (
            <QuoteCard {...data} key={i} />
          ))}
        </CardGroup>
      </RelatedPostsWrapper>
    )
  );
};

export default HomeownerQuotes;
